import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportingRoutingModule } from './reporting-routing.module';
import { TrainingStatusComponent } from './training-status/training-status.component';
import { SharedModule } from '../shared/shared.module';
import { ToastModule } from 'primeng/toast';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BptProgressSpinnerModule } from 'bpt-ui-library/bpt-progress-spinner';
import { BptDateTimeModule } from 'bpt-ui-library/bpt-datetime';
import { BptTextInputModule } from 'bpt-ui-library/bpt-text-input';
import { BptNumericInputModule } from 'bpt-ui-library/bpt-numeric-input';
import { BptTagsModule } from 'bpt-ui-library/bpt-tags';
import { BptDropdownModule } from 'bpt-ui-library/bpt-dropdown';
import { SpinnerComponent } from '../shared-components/spinner/spinner.component';
import { EmptyResultsComponent } from '../shared-components/empty-results/empty-results.component';
import { LabelComponent } from '../shared-components/label/label.component';
import { PanelHubComponent } from '../shared-components/panel-hub/panel-hub.component';

@NgModule({
  declarations: [
    TrainingStatusComponent
  ],
  imports: [
    CommonModule,
    ReportingRoutingModule,
    SharedModule,
    ToastModule,
    FormsModule,
    ReactiveFormsModule,
    BptProgressSpinnerModule,
    BptDateTimeModule,
    BptTextInputModule,
    BptNumericInputModule,
    BptTagsModule,
    BptDropdownModule,
    SpinnerComponent,
    EmptyResultsComponent,
    LabelComponent,
    PanelHubComponent
  ]
})
export class ReportingModule { }
